import {ABusiness} from "@/views/editor/service/business";
import {h} from "vue";
import {RedEnvelopeFilled} from "@ant-design/icons-vue";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {RadioGroupChildOption} from "ant-design-vue/es/radio/Group";

export abstract class ARedEnvelope extends ABusiness {
    readonly icon = () => h(RedEnvelopeFilled, {style: 'color: #a855f7'});
    readonly title = '红包';
    readonly description = '一手用浏览红包提升用户停留时长，另一手用分享红包拉动新增用户，一举两得。';

    protected constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }

    implementations(status: EActivityStatus): RadioGroupChildOption[] {
        return {
            active: [{value: 'red_envelope', label: '红包'}],
            preheating: [{value: 'red_envelope', label: '红包'}],
            finished: []
        }[status]
    }
}